import {
  useCallback,
  useMemo
} from 'react';
import { useLocale } from 'entities/application';
import { useIsActiveGoogleMap } from 'entities/map';
import config from 'config';
import { loadScriptFromDocument } from 'shared/utils';

export const useLoadGoogleMapLibraries = () => {
  const locale = useLocale();

  const loadGoogleMapLibraries = useCallback(() => {
    const googleMapApiURL = `https://maps.googleapis.com/maps/api/js?&key=${config.googleAppKey}&libraries=maps,places,routes,geometry&v=3.64&language=${locale}&callback=initMap`;
    return loadScriptFromDocument(googleMapApiURL, document.querySelector('head'));
  }, [locale]);

  return loadGoogleMapLibraries;
};

export const useLoadHereMapLibraries = () => {
  const loadHereMapLibraries = useCallback(async () => {
    const headElement = document.querySelector('head');
    await loadScriptFromDocument('https://js.api.here.com/v3/3.2/mapsjs-core.js', headElement);
    return Promise.all([
      loadScriptFromDocument('https://js.api.here.com/v3/3.2/mapsjs-service.js', headElement),
      loadScriptFromDocument('https://js.api.here.com/v3/3.2/mapsjs-mapevents.js', headElement),
      loadScriptFromDocument('https://js.api.here.com/v3/3.2/mapsjs-ui.js', headElement),
      loadScriptFromDocument('https://js.api.here.com/v3/3.2/mapsjs-clustering.js', headElement),
      loadScriptFromDocument('https://js.api.here.com/v3/3.2/mapsjs-data.js', headElement),
    ]);
  }, []);

  return loadHereMapLibraries;
};

export const useLoadMapLibraries = () => {
  const isActiveGoogleMap = useIsActiveGoogleMap();
  const loadGoogleMapLibraries = useLoadGoogleMapLibraries();
  const loadHereMapLibraries = useLoadHereMapLibraries();

  const loadMapLibraries = useMemo(() => (
    isActiveGoogleMap
      ? loadGoogleMapLibraries
      : loadHereMapLibraries
  ), [
    isActiveGoogleMap,
    loadGoogleMapLibraries,
    loadHereMapLibraries
  ]);

  return loadMapLibraries;
};
